import { mapActions, mapGetters } from 'vuex';

/**
 * Helper mixin that checks if the user is connected with NetSuite.
 * This guard is made as a mixin because we need to fetch the data
 * before checking, therefore, this can't be on the router level.
 */
export default {
  computed: {
    ...mapGetters('entities/users', ['isDistributorNetSuiteConnected']),
  },
  methods: {
    ...mapActions('entities/users', ['initDistributorLoggedUser']),
  },
  async created() {
    await this.initDistributorLoggedUser();
    if (!this.isDistributorNetSuiteConnected) {
      this.$router.replace({
        name: 'distributor-netsuite-not-connected',
        params: {
          flash: {
            title: `You are not connected to ${this.$t('netsuite.name')}.`,
            type: 'fail',
          },
        },
      });
    }
  },
};
